import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummary, type AccordionSummaryProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const MUIAccordionSummary: React.FC<AccordionSummaryProps> = ({ children, ...rest }) => {
  const { t } = useTranslation();

  return (
    <StyledAccordionSummary expandIcon={<ExpandMoreIcon />} {...rest}>
      {children}
      <ShowMoreText data-testid="accordion-show-more">{t("buttons.show")}</ShowMoreText>
    </StyledAccordionSummary>
  );
};

const StyledAccordionSummary = styled(AccordionSummary)`
  & .MuiAccordionSummary-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const ShowMoreText = styled.div`
  font-size: 14px;
  cursor: pointer;
`;
